export default function UsageScenarios() {
  const scenarios = [
    {
      title: 'Glamping Resorts',
      description: 'Create unique outdoor accommodation experiences with luxury amenities in natural settings',
      benefits: ['High nightly rates', 'Year-round operation', 'Low maintenance', 'Eco-tourism appeal'],
      image: '/images/ai-space-capsule-pods-in-beautiful-mountain-bd049e.webp',
      icon: 'ri-tent-line'
    },
    {
      title: 'Boutique Hotels',
      description: 'Expand room inventory quickly with distinctive capsule suites that attract design-conscious travelers',
      benefits: ['Quick deployment', 'Unique selling point', 'Premium pricing', 'Instagram-worthy'],
      image: '/images/ai-modern-boutique-hotel-with-futuristic-sp-ff74d0.webp',
      icon: 'ri-hotel-line'
    },
    {
      title: 'Short-Stay Accommodation',
      description: 'Stand out in the short-term rental market with a one-of-a-kind space capsule experience',
      benefits: ['High occupancy rates', 'Premium bookings', 'Repeat guests', 'Strong reviews'],
      image: '/images/ai-space-capsule-vacation-rental-in-scenic--eca70e.webp',
      icon: 'ri-home-smile-line'
    },
    {
      title: 'Scenic Viewpoints',
      description: 'Monetize prime locations with overnight stays offering unparalleled views and experiences',
      benefits: ['Location advantage', 'Minimal footprint', 'Seasonal flexibility', 'High margins'],
      image: '/images/ai-space-capsule-pod-positioned-at-mountain-fa0c01.webp',
      icon: 'ri-landscape-line'
    }
  ];

  return (
    <section id="scenarios" className="relative py-24 lg:py-32 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Usage <span className="text-cyan-400">Scenarios</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Versatile applications for hospitality, tourism, and unique accommodation experiences
          </p>
        </div>

        {/* Scenarios */}
        <div className="space-y-16">
          {scenarios.map((scenario, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-3xl overflow-hidden border border-cyan-500/30 group">
                  <div className="w-full h-96">
                    <img 
                      src={scenario.image}
                      alt={scenario.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-cyan-500/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className={`${scenario.icon} text-3xl text-cyan-400`}></i>
                  </div>
                  <h3 className="text-3xl font-medium text-white">{scenario.title}</h3>
                </div>
                
                <p className="text-lg text-gray-400 mb-6 leading-relaxed">
                  {scenario.description}
                </p>

                <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-2xl p-6">
                  <h4 className="text-lg font-medium mb-4 text-cyan-400">Key Benefits</h4>
                  <ul className="space-y-3">
                    {scenario.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className="w-5 h-5 bg-cyan-500/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-sm text-cyan-400"></i>
                        </div>
                        <span className="text-gray-300">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ROI Highlight */}
        <div className="mt-20 bg-gradient-to-br from-cyan-500/10 to-transparent border border-cyan-500/30 rounded-3xl p-8 lg:p-12 text-center">
          <h3 className="text-3xl font-medium mb-6">Investment Returns</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div>
              <div className="text-4xl font-thin text-cyan-400 mb-2">15-25%</div>
              <div className="text-sm text-gray-400">Annual ROI</div>
            </div>
            <div>
              <div className="text-4xl font-thin text-cyan-400 mb-2">3-5 years</div>
              <div className="text-sm text-gray-400">Payback Period</div>
            </div>
            <div>
              <div className="text-4xl font-thin text-cyan-400 mb-2">$150-300</div>
              <div className="text-sm text-gray-400">Avg. Nightly Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}